import { render, staticRenderFns } from "./LeadsCard.vue?vue&type=template&id=03375ed8&scoped=true&"
import script from "./LeadsCard.vue?vue&type=script&lang=js&"
export * from "./LeadsCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCard.vue?vue&type=style&index=0&id=03375ed8&lang=scss&scoped=true&"
import style1 from "./LeadsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03375ed8",
  null
  
)

export default component.exports